import axios from './BaseService';

const API_URL = process.env.REACT_APP_API_URL;
const EMPRESA_URL = `${API_URL}/empresa/`;

export async function getConfigSons(cod_empresa, token) {
  const codOrg = sessionStorage.getItem('cod_org');
  const headers = { authorization: token };

  const { data } = await axios.get(
    `${EMPRESA_URL}${cod_empresa}/sons?cod_org=${codOrg}&cod_empresa=${cod_empresa}`,
    { headers }
  );
  return data.config_sons;
}

export async function salvarConfigSons(cod_empresa, configParcial, token) {
  const codOrg = sessionStorage.getItem('cod_org');
  const headers = { authorization: token };

  const { data } = await axios.patch(
    `${EMPRESA_URL}${cod_empresa}/sons?cod_org=${codOrg}&cod_empresa=${cod_empresa}`,
    configParcial,
    { headers }
  );
  return data.config_sons;
}

export async function uploadSom(cod_empresa, evento, arquivo, token) {
  const codOrg = sessionStorage.getItem('cod_org');
  const headers = { authorization: token };

  const formData = new FormData();
  formData.append('arquivo', arquivo);

  const { data } = await axios.post(
    `${EMPRESA_URL}${cod_empresa}/sons/upload/${evento}?cod_org=${codOrg}&cod_empresa=${cod_empresa}`,
    formData,
    { headers }
  );
  return data.config_sons;
}
